// // store.js
// import { configureStore } from '@reduxjs/toolkit';
// import authReducer from './slice';

// export const store = configureStore({
//   reducer: {
//     auth: authReducer,
//   },
//   middleware: (getDefaultMiddleware) =>
//     getDefaultMiddleware({
//       serializableCheck: {
//         ignoredActions: ['persist/PERSIST'],
//       },
//     }),
// });

// export default store;


import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slice';
import adminReducer from './admindaetails';  // ⬅️ import this

export const store = configureStore({
  reducer: {
    auth: authReducer,
    admin: adminReducer,   // ⬅️ add here
  },
});
